import Vue from '@/main'
import store from "@/store/store.js"
import ChatContactRequest from "@/http/requests/chatContact/index"

export default {
    async fetch({ commit }) {
      return new Promise((resolve, reject) => {
          ChatContactRequest.fetchSumOfTickets(store.getters["instance/chosenInstanceIds"]).then((response) => {
            commit('SET_SUM_OF_TICKETS', response.data.data.sumOfTickets)

            Vue.$events.off('SumOfTickets')
            Vue.$events.on('SumOfTickets', ({type:type, data:data}) => {
                if ( !store.getters["instance/chosenInstanceIds"].includes(data.instance_id) ) { return; }
                commit('PREPARE_SUM_OF_TICKETS', { type, data });
            });

            resolve(response)
          }).catch((error) => {reject(error)});
      });
    },
    prepareSumOfTickets({ commit }, {type:type, data: data}){
        commit('PREPARE_SUM_OF_TICKETS', {type, data});
    },
    addInSumOfTickets({ commit }, {'data': data, 'inInbox' : inInbox}) {
        commit('ADD_IN_SUM_OF_TICKETS', {'data': data, 'inInbox' : inInbox});
    },
    subInSumOfTickets({ commit }, {'data': data, 'inInbox' : inInbox}) {
        commit('SUB_IN_SUM_OF_TICKETS', {'data': data, 'inInbox' : inInbox});
    },
    updateInSumOfTickets({ commit }, {'data': data}) {
      commit('UPDATE_IN_SUM_OF_TICKETS', {'data': data});
    }
}